import {
  validateAt,
  validateAll,
  prepareApiErrors,
} from '@/services/Validator/utils/validate'
import { makeAutoObservable } from 'mobx'
import { Schema } from 'yup'

interface Errors {
  [key: string]: any
}

export class Validator {
  errors: Errors = {}

  constructor(private _schema: Schema) {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  get isValid() {
    return (
      Object.keys(this.errors).length === 0 ||
      Object.values(this.errors).every((i) => !i)
    )
  }

  setErrors(errors: Errors) {
    this.errors = { ...this.errors, ...prepareApiErrors(errors) }
  }

  /**
   * @param {string} path - for schema
   * @param {*} value
   * @return { boolean }
   */
  validateAt(path: string, value: any): boolean {
    const { error, status } = validateAt(this._schema, path, value)
    this.errors = { ...this.errors, [path]: error }
    return status
  }

  /**
   * @param {object} data
   * @returns {boolean}
   */
  validateAll(data: any): boolean {
    const { errors, status } = validateAll(this._schema, data)
    this.errors = errors
    return status
  }

  validateFilled(data: any): boolean {
    return Object.entries(data).reduce((result, [key, value]) => {
      const valueNotEmptyString =
        typeof value !== 'string' || value.length !== 0

      const valueNotEmptyArray = !Array.isArray(value) || value.length !== 0

      if (
        value != null &&
        valueNotEmptyArray &&
        valueNotEmptyString &&
        typeof value != 'boolean'
      ) {
        return this.validateAt(key, value) && result
      } else {
        return true
      }
    }, true)
  }
}
